customElements.get('np-modal') || customElements.define('np-modal',
  class extends HTMLElement {
    constructor() {
      super()
      this.dialog = this.querySelector(".np-modal__dialog");
      this.link = this.querySelector(".np-modal__hyperlink");
      // this.close = this.querySelector(".np-modal__close");
      this.closeX = this.querySelector(".np-modal__close-x");
    }
    connectedCallback() {
      this.handleOpen()
      this.handleCloseClick()
      this.handleBackdropClick()
    }

    handleOpen() {
      this.link.addEventListener("click", (e) => {
        e.preventDefault()
        this.dialog.showModal();
        this.dialog.scrollTo(0, 0);
      });
    }

    handleClose() {
      setTimeout(() => {
        this.dialog.close();
        this.dialog.classList.remove("np-modal__dialog--closing")
      }, 500);
      this.dialog.classList.add("np-modal__dialog--closing")
    }

    handleCloseClick() {
      // this.close.addEventListener("click", () => {
      //   this.handleClose();
      // });

      this.closeX.addEventListener("click", () => {
        this.handleClose();
      })
    }

    handleBackdropClick() {
      this.dialog.addEventListener('click', (event) => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientY < rect.top || event.clientY > rect.bottom ||
          event.clientX < rect.left || event.clientX > rect.right) {
          this.handleClose();
        }
      })
    }

  }
)
